<template>
  <div>
    <profile-student></profile-student>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProfileStudent from '../Student/Profile'

export default {
  components: {
    profileStudent: ProfileStudent
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
  }
}
</script>